import qs from 'qs'

export default {
    namespaced: true,
    state: {
        logged_in: false,
        login_popup: false,
        login_info: {},
        forgot_popup: false,
        forgot_msg: "",
        remember_popup: false,
        register_popup: false,
        register_info: {},

        simple_data: {},
        billings_data: {},
        shipping_data: {},
        company_data: {},
        acceptance: {},
        passwords: {}

    },
    mutations: {
        set_logged_in(state, is_logged_in) {
            state.logged_in = is_logged_in;
        },
        set_login_popup(state, showing) {
            state.login_popup = showing;
        },
        set_forgot_popup(state, showing) {
            state.forgot_popup = showing;
        },
        set_forgot_msg(state, msg) {
            state.forgot_msg = msg;
        },
        set_login_info(state, data) {
            state.login_info = data;
        },
        set_register_popup(state, showing) {
            state.register_popup = showing;
        },
        set_register_info(state, info) {
            state.register_info = info;
        },


        set_simple_data(state, data) {
            state.simple_data = data;
        },
        set_billings_data(state, data) {
            state.billings_data = data;
        },
        set_shipping_data(state, data) {
            state.shipping_data = data;
        },
        set_company_data(state, data) {
            state.company_data = data;
        },
        set_acceptance(state, data) {
            state.acceptance = data;
        },
        set_passwords(state, data) {
            state.passwords = data;
        }

    },
    actions: {
        async usersRegisterAndUpdate({commit, state}, data) {
            let parameters = {
                action: 'user_actions',
                data: data,
                security: window.global.ajax_nonce,

            }
            // commit('set_loader', true);
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                commit("set_register_info", res.data)
            })
        },
        async loginUser({commit, state}, login_data) {
            let parameters = {
                action: 'login_user',
                login: login_data,
                security: window.global.ajax_nonce,
                // security: window.global.security
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                commit("set_login_info", res.data.data)
                if (res.data.data.loggedin) {
                    commit('set_logged_in', true);
                }
            })
        },
        async checkIfIsLogin({commit, state}) {
            let parameters = {
                action: 'is_loggedin',
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                if (res.data) {
                    commit('set_logged_in', true);
                }
            }).catch((e) => {
                commit('set_logged_in', false);
            })
        },
        async logoutUser({commit, state}) {
            let parameters = {
                action: 'user_logout',
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                if (res.data.logout) {
                    commit('set_logged_in', false);
                }
            })
        },
        async resetPassword({commit, state}, email) {
            let parameters = {
                action: 'reset_password',
                email: email,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                if (res.data.data.msg) {
                    commit('set_forgot_msg', res.data.data.msg);
                }
            })
        },
        async getLoginUserData({commit, state}) {
            let parameters = {
                action: 'logged_in_user_data',
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                if (res.data.success) {
                    let data = res.data.data
                    commit('set_simple_data', data.simple_data)
                    commit('set_company_data', data.company_data)
                    commit('set_billings_data', data.billings_data)
                    commit('set_shipping_data', data.shipping_data)
                }
            })
        },
    },
    getters: {
        is_logged_in: (state) => state.logged_in,
        login_popup: (state) => state.login_popup,
        register_popup: (state) => state.register_popup,
        get_register_info: (state) => state.register_info,
        forgot_popup: (state) => state.forgot_popup,
        forgot_msg: (state) => state.forgot_msg,
        get_login_info: (state) => state.login_info,

        get_simple_data: (state) => state.simple_data,
        get_billings_data: (state) => state.billings_data,
        get_shipping_data: (state) => state.shipping_data,
        get_company_data: (state) => state.company_data,
        get_acceptance: (state) => state.acceptance,
        get_passwords: (state) => state.passwords,
    }
};